// Vue app
import Vue from "vue";
import nwpApp from "./nwp/nwpApp.vue";
import shareApp from "./share/shareApp";

import "@/styles/main.css";
import TrackHelper from "@/helpers/utilities/TrackHelper";

import PiniaStore from "@/stores";
import { i18n, loadLanguageAsync } from "@/helpers/utilities/I18nHelper";

// Helpers
import { nwpRouter, setTranslater } from "./nwp/nwpRouter";
import { shareRouter } from "./share/shareRouter";
import { default as store } from "@/helpers";
import apiGraph from "@/helpers/api/apiGraph";
import apiSkobo from "@/helpers/api/apiSkobo";
import apiUchi from "@/helpers/api/apiUchi";

import * as Tabs from "vue-slim-tabs";

import { SessionHelper } from "@/helpers/utilities/sessionHelper";
import FontAwesomeHelper from "@/helpers/utilities/FontAwesomeHelper";

// Plugins
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import GlobalSnackbar from "@/components/Shared/GlobalSnackbar";

/**********************************************/
// TRACKER
/**********************************************/
TrackHelper.initialize();

/**
 *  Application with login context requiring the user to be invited to the MS Tennant
 */
async function initializeLoggedInContext() {
  try {
    let apiTokenFromQuery;

    if (window.location.search.substring(1).indexOf("token=") === 0) {
      apiTokenFromQuery = window.location.search.substring(1).replace("token=", "");
      if (apiTokenFromQuery != null || apiTokenFromQuery.length != 0) {
        // Remove token from URL
        window.history.pushState("object or string", "Title", window.location.href.split("?")[0]);
      }
    } else {
      apiTokenFromQuery = SessionHelper.nctSessionToken();
    }

    if (apiTokenFromQuery && apiTokenFromQuery.length) {
      // Setup router
      SessionHelper.login(apiTokenFromQuery);
      apiSkobo.init(nwpRouter);
      apiUchi.init(nwpRouter);

      // Setup pinia
      const pinia = PiniaStore.init();

      /**********************************************/
      // SETUP GRAPH API
      /**********************************************/
      await apiGraph.initGraphApi(
        import.meta.env.VITE_APP_MSGRAPH_API_ENDPOINT,
        import.meta.env.VITE_APP_MSGRAPH_API_ENDPOINT_NEW
      );

      setTranslater(i18n);

      Object.defineProperty(Vue.prototype, "$locale", {
        get: function () {
          return i18n.locale;
        },
        set: function (locale) {
          i18n.locale = locale;
        }
      });

      /**********************************************/
      // FONT-AWESOME
      /**********************************************/
      FontAwesomeHelper.initFontAwesome();
      Vue.component("font-awesome-icon", FontAwesomeIcon);

      /**********************************************/
      // MISCELLANEOUS SETUP
      /**********************************************/
      Vue.prototype.$skboMessage = GlobalSnackbar.messageState;
      Vue.prototype.$ncProfile = { HideFileExtensions: false };
      Vue.use(Tabs);

      Vue.config.productionTip = false;

      /**********************************************/
      // INIT VUE APP
      /**********************************************/

      new Vue({
        router: nwpRouter,
        store,
        pinia,
        i18n,
        render: h => h(nwpApp)
      }).$mount("#app");

      /**********************************************/
      // Forms detection for handling if input has value
      /**********************************************/

      document.addEventListener("change", function (event) {
        let element = event.target;
        if (element && element.matches(".form-element-field")) {
          element.classList[element.value ? "add" : "remove"]("-hasvalue");
        }
      });
    } else {
      // If we have a route but is not actively logged out (eg. we do  not have a system name) redirect to kviklogin
      if (!SessionHelper.customerSystemName) {
        sendToKviklogin();
        return;
      }

      const pinia = PiniaStore.init();

      loadLanguageAsync(import.meta.env.VITE_APP_I18N_FALLBACK_LOCALE, import.meta.env.VITE_APP_I18N_FALLBACK_VARIANT);

      new Vue({
        nwpRouter,
        pinia,
        i18n,
        render: h => h(nwpApp)
      }).$mount("#app");
    }
  } catch (e) {
    sendToKviklogin();
  }
}

/**
 * Anonymous application for share through direct files
 */
async function initializeAnonymousContext() {
  try {
    // Setup pinia
    const pinia = PiniaStore.init();

    /**********************************************/
    // FONT-AWESOME
    /**********************************************/
    FontAwesomeHelper.initFontAwesome();
    Vue.component("font-awesome-icon", FontAwesomeIcon);

    /**********************************************/
    // MISCELLANEOUS SETUP
    /**********************************************/

    Vue.config.productionTip = false;

    /**********************************************/
    // INIT VUE APP
    /**********************************************/

    await new Vue({
      router: shareRouter,
      pinia,
      i18n,
      render: h => h(shareApp)
    }).$mount("#app");

    const browserLanguage = navigator.language.substring(0, 1);

    await loadLanguageAsync(browserLanguage == "da" ? "da" : "en", "nwp");

    // eslint-disable-next-line no-empty
  } catch {}
}

const regex = /^(http|https):\/\/[a-z0-9.:]*\/[a-z0-9]{16}$/; // https://regex101.com/r/TI5tKX/2

if (regex.test(window.location.href)) {
  initializeAnonymousContext();
} else {
  initializeLoggedInContext();
}

/**
 *
 */
function sendToKviklogin() {
  SessionHelper.nextLoginRoute = window.location.pathname;
  if (import.meta.env.VITE_APP_NCT_LOGIN_ENDPOINT) {
    window.location.replace(import.meta.env.VITE_APP_NCT_LOGIN_ENDPOINT);
  } else {
    window.location.replace("https://kviklogin.dk");
  }
}
